import ApplicationsRouter from './Applications.router';

export default ApplicationsRouter;

export { default as applicationsRoutes } from './Applications.routes';
